import { GiroPaymentsTableColumnsIntl } from 'types/i18n';

export const giroPaymentsTableColumnsIntl: GiroPaymentsTableColumnsIntl = {
  id: 'id',
  unp: 'УНП (ИНН / TIN)',
  organization: 'Организация',
  fullName: 'ФИО',
  recievedAt: 'Дата поступления',
  recievedAmount: 'Поступило',
  creditedAmount: 'На баланс',
  status: 'Статус',
  updatedAt: 'Обновление',
  createdAt: 'Дата создания',
};
